angular.module("acl.visualizer.summary", ["acl.angular.ui", "acl.common.event", "acl.visualizer.dataModel"]);
